import React from "react";
import PropTypes from "kf-proptypes/widgets";
import { Tabs as AntTabs } from "antd";
import "antd/es/tabs/style/css";

import { BoxTabs, BoxTab, BOX_TAB_VISIBLE_TYPES } from "./boxtab.jsx";
import { RoundTab, RoundTabs, ROUND_TABS_SIZE } from "./roundtab.jsx";
import {
  ScrollableTabs,
  SCROLLABLE_TABS_HIGHLIGHT_TYPES
} from "./scrollabletab.jsx";
import { FlowTab, FlowTabs } from "./flowtab.jsx";

import styles from "./tab.css";

const { TabPane: AntTabPane } = AntTabs;

export const TAB_SIZES = {
  MEDIUM: "medium",
  SMALL: "small"
};

export function Tabs(props) {
  const {
    children,
    defaultActiveTabId,
    activeTabId,
    onChange,
    className,
    size = TAB_SIZES.MEDIUM,
    destroyInactiveTabPane = false,
    rightAction
  } = props;
  const _children = React.Children.toArray(children);
  let additionalProps = {};
  if (rightAction) {
    additionalProps.tabBarExtraContent = { right: rightAction };
  }

  return (
    <AntTabs
      className={`${styles.tabs} ${styles[size]} ${className}`}
      defaultActiveKey={defaultActiveTabId}
      activeKey={activeTabId}
      onChange={onChange}
      destroyInactiveTabPane={destroyInactiveTabPane}
      {...additionalProps}
    >
      {_children.map((child, index) => {
        return (
          child?.props && (
            <AntTabPane
              tab={
                <div>
                  <span>{child.props.title}</span>
                  {child.props.number ? (
                    <span className={styles.number}>{child.props.number}</span>
                  ) : (
                    ""
                  )}
                </div>
              }
              key={child.props.tabId}
              disabled={child.props.disabled}
              className={child.props.className}
            >
              {child.props.children}
            </AntTabPane>
          )
        );
      })}
    </AntTabs>
  );
}

Tabs.defaultProps = {
  size: TAB_SIZES.MEDIUM,
  destroyInactiveTabPane: false
};

Tabs.propTypes = {
  /** A list of Tab components. */
  children: PropTypes.node.isRequired,
  /** Initial active TabPane's key, if activeKey is not set. */
  defaultActiveTabId: PropTypes.string,
  /** Current TabPane's key */
  activeTabId: PropTypes.string.isRequired,
  /** A callback function that gets invoked when current tab changes. */
  onChange: PropTypes.func.isRequired,
  /** Size property is used to defined the size of the tab as medium and small. */
  size: PropTypes.oneOf(Object.values(TAB_SIZES)),
  /** To override the existing styles of the component */
  className: PropTypes.string,
  /** This prop is used to destory the inactive tab from dom */
  destroyInactiveTabPane: PropTypes.bool,
  /** This prop is used to render any node  at the right of the tab */
  rightAction: PropTypes.node
};

export function Tab(props) {
  const { children } = props;
  return children;
}

Tab.propTypes = {
  children: PropTypes.node,
  tabId: PropTypes.string
};

export { BoxTabs, BoxTab, BOX_TAB_VISIBLE_TYPES, AntTabs };

export { ScrollableTabs, SCROLLABLE_TABS_HIGHLIGHT_TYPES };

export { RoundTab, RoundTabs, ROUND_TABS_SIZE };

export { FlowTab, FlowTabs };
